import { useMutation } from '@tanstack/react-query'
import { axiosPatch } from 'Redux/axiosHelper'
import { FinalEventEmailTemplatePayload } from 'types/event/eventStep5'

const addEmailTemplateToEvent = async ({
  payload,
  referenceId,
  reference,
}: {
  payload: FinalEventEmailTemplatePayload
  referenceId: string
  reference: 'organization-events' | 'league' | 'organization'
}) => {
  const response = await axiosPatch(
    payload,
    `v1/${reference}/${referenceId}/new/add-email-template`,
  )
  return response.data
}

export const useAddEmailTemplateToEvent = () => {
  return useMutation(addEmailTemplateToEvent, {
    onSuccess: data => {},
  })
}

//update email template
const updateEmailTemplateForEvent = async ({
  payload,
  referenceId,
  templateId,
  reference,
}: {
  payload: FinalEventEmailTemplatePayload
  referenceId: string
  templateId: string
  reference: 'organization-events' | 'league' | 'organization'
}) => {
  const response = await axiosPatch(
    payload,
    `v1/${reference}/${referenceId}/new/edit-email-template/${templateId}`,
    '',
    false,
  )
  return response.data
}

export const useUpdateEmailTemplateForEvent = () => {
  return useMutation(updateEmailTemplateForEvent)
}
